import { InjectionToken } from '@angular/core';
import { StableCache } from '@nk/caching-lib';
import { AppIconEntity, WithUuid } from '@nk/data-entities-lib';
import { Dict } from '@nk/utils-lib';
import { Observable } from 'rxjs';

export interface AppIconApiService {
  appIconDictCache: StableCache<AppIconApiService, () => Observable<Dict<WithUuid<AppIconEntity>>>>;
}

export const APP_ICON_API_SERVICE_TOKEN = new InjectionToken<AppIconApiService>('AppIconApiService');
